// extracted by mini-css-extract-plugin
module.exports = {"ControlPanel":"ControlPanel_ControlPanel__2RG36","Group":"ControlPanel_Group__2-HoR","GroupEnd":"ControlPanel_GroupEnd__33grD"};